export default "__VITE_ASSET__BmgjOF24__"